(function ($, window, document, config) {
    "use strict";

    /**
     * features sticky menu
     * */
    const isFeaturedPage = document.body.classList.contains( 'page-template-template-features' );
    if ( isFeaturedPage ) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 520) {
                document.getElementById('featuresMenu').classList.add('fixed-top');
                // add padding top to show content behind navbar
                let navbar_height = document.querySelector('.navbar').offsetHeight;
                document.body.style.paddingTop = navbar_height + 'px';
            } else {
                document.getElementById('featuresMenu').classList.remove('fixed-top');
                // remove padding top from body
                document.body.style.paddingTop = '0';
            }
        });
    }

})(jQuery, window, document, wpAyyash);
